import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchRecentBoards } from '../../redux/Slices/boardsSlice';
import { setLoading } from '../../redux/Slices/boardSlice';
import { closeExpandableColumn } from '../../redux/Slices/expandableColumnSlice';
import Spinner from '../Global/Spinner';
import StarFill from '../icons/StarFill';
import './RecentColumn.scss';

const RecentColumn = ({ boardId }) => {
    const dispatch = useDispatch();
    const { recentBoards, recentStatus } = useSelector((state) => state.boards) || [];
    const { user } = useSelector((state) => state.user);

    useEffect(() => {
        // Fetch only once when status is idle to avoid loops on empty results
        if (recentStatus === 'idle') {
            dispatch(fetchRecentBoards({ limit: 10, useCache: true }));
        }
    }, [dispatch, recentStatus]);

    const handleBoardLink = () => {
        dispatch(setLoading(true));
        dispatch(closeExpandableColumn());
    }

    return (
        <div className='recent-column'>
            <div className="recent-column__content">
                {recentStatus === 'loading' ? (
                    <div className="loading-container">
                        <Spinner size={30} color="#3498db" speed={1.5} />
                    </div>
                ) : recentBoards?.length > 0 ? (
                    <div className="recent-list">
                        {recentBoards.map(board => (
                            <div
                                className={`recent-item${boardId === board?.shortId ? ' active' : ''}`}
                                key={board._id}
                            >
                                <div className="recent-avatar">
                                    {board.cover?.sizes?.thumbnail ? (
                                        <div
                                            className="board-cover"
                                            style={{ backgroundImage: `url('${board.cover?.sizes?.medium}')` }}
                                        >
                                            {user?.user?.starredBoards && user?.user?.starredBoards.includes(board._id) && (
                                                <StarFill color={'#FFD700'} size={16} />
                                            )}
                                        </div>
                                    ) : (
                                        <div className="board-placeholder">
                                            {user?.user?.starredBoards && user?.user?.starredBoards.includes(board._id) && (
                                                <StarFill color={'#FFD700'} size={16} />
                                            )}
                                        </div>
                                    )}
                                </div>

                                <div className="recent-content">
                                    <div className="recent-text">
                                        <strong>{board.title}</strong>
                                    </div>
                                    <div className="recent-subtitle">{board.workspace.name}</div>
                                </div>

                                {boardId !== board?.shortId && (
                                    <Link
                                        onClick={handleBoardLink}
                                        className="recent-link"
                                        to={board.permalink}
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="empty-state">
                        <div className="empty-icon">
                            🕒
                        </div>
                        <h3>No recent boards</h3>
                        <p>Boards you visit will appear here for quick access.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RecentColumn;
